import { useMemo, useState } from "react";
import { SearchDateSingleForm } from "src/components/common/form/search/SearchDateSingleForm";
import { SearchDropDownForm } from "src/components/common/form/search/SearchDropDownForm";
import { SearchSectionForm } from "src/components/common/form/search/SearchSectionForm";
import { CompanyDto } from "src/dtos/company/companyDto";
import { defaultSysCodeDto, SysCodeDto } from "src/dtos/code/sysCodeDto";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";
import { useEQM1011_R01Store } from "./Store_EQM1011_R01";

/**
 * EQM1011_R01 검색조건 영역 (사업장, 조회일자, 데이터종류).
 * 데이터종류는 공통코드 PLCADDRESS 대신 plc_tag 목록을 쓴다(6차 요청).
 * @returns 검색조건 폼
 */
export const SearchSection_EQM1011_R01 = () => {
    const { EQM1011_R01Filter, setEQM1011_R01Filter, EQM1011_R01TagList } = useEQM1011_R01Store();
    const { compCdList } = useCommonCodeStore();
    const [pickerVisible, setPickerVisible] = useState(false);
    const [pickerPosition, setPickerPosition] = useState({ top: 0, left: 0 });

    // 데이터종류 옵션 — 태그 목록을 공통 SearchDropDownForm 형식(SysCodeDto: minorCd = tag_id, codeNm = 태그명 (tag_id))으로 변환. 태그 목록이 바뀔 때만 다시 계산
    const tagOptionList = useMemo<SysCodeDto[]>(
        () => EQM1011_R01TagList.map(tag => ({
            ...defaultSysCodeDto,
            minorCd: tag.tagId,
            codeNm: `${tag.tagName} (${tag.tagId})`,
        })),
        [EQM1011_R01TagList],
    );

    return (
        <SearchSectionForm>
            {/* 사업장 선택 — 'all'이면 빈 값(전체) */}
            <SearchDropDownForm<CompanyDto>
                label="사업장"
                value={EQM1011_R01Filter.compCd}
                optionList={compCdList}
                onChangeValue={(value) => setEQM1011_R01Filter({
                    compCd: value === 'all' ? '' : value,
                })}
            />
            {/* 조회일자 — 하루 단위 조회 */}
            <SearchDateSingleForm
                label="조회일자"
                visible={pickerVisible}
                setVisible={setPickerVisible}
                value={EQM1011_R01Filter.baseDate}
                onChange={(baseDate) => setEQM1011_R01Filter({ baseDate })}
                pickerPosition={pickerPosition}
                setPickerPosition={setPickerPosition}
            />
            {/* 데이터종류(PLC 태그) 선택 — 값이 없으면 'all'(전체)로 표시, 'all'·빈 값 선택 시 tagId를 비운다 */}
            <SearchDropDownForm<SysCodeDto>
                label="데이터종류"
                value={EQM1011_R01Filter.tagId || 'all'}
                optionList={tagOptionList}
                onChangeValue={(value) => setEQM1011_R01Filter({
                    tagId: value === 'all' ? '' : value,
                })}
                wrapperOption={{ selectStyle: 'w-[200px] min-w-[200px]' }}
            />
        </SearchSectionForm>
    );
};
